<kendo-treelist
[kendoTreeListFlatBinding]="projectItems"
idField="id"
parentIdField="parentId"
kendoTreeListExpandable
kendoTreeListSelectable
[initiallyExpanded]="true"
>
  	<kendo-treelist-column [width]="22" [columnMenu]="false">
        <ng-template kendoTreeListCellTemplate let-dataItem>
            <kendo-checkbox [checkedState]="dataItem.selected == null ? 'indeterminate' : dataItem.selected" (change)="onCheckboxChange($event, dataItem)"></kendo-checkbox>
        </ng-template>
    </kendo-treelist-column>

    <kendo-treelist-column
        [expandable]="true"
        field="name"
		title="Name"
		[width]="250"
	>
	</kendo-treelist-column>

	<kendo-treelist-column
		field="height"
		title="Height"
		[width]="50"
	>
	</kendo-treelist-column>

	<kendo-treelist-column
		field="width"
		title="Width"
		[width]="50"
	>
	</kendo-treelist-column>
    
	<kendo-treelist-column
		field="depth"
		title="Depth"
		[width]="50"
	>
	</kendo-treelist-column>

</kendo-treelist>
